<template>
  <div>
    <div v-if="dataLoaded">
      <fiche-container
          ref="FICHE_CONTAINER"
          :fiche="selectedFiche"
          :route="notifRoute"
          :attribut="attribut"
          :toggle-notif="toggleNotif"
          @back="back"
          @select-item="selectItem">
      </fiche-container>
    </div>
    <section-container
        :dialog-open="showWizard"
        :section="sectionWizard"
        @close-dialog="hideWizard">
    </section-container>
  </div>
</template>

<script lang="ts">
import Route from '@/generated/classes/Route';
import {FwkModules, RessourceFwkModule} from '@/ressources/globalRessources';
import ModuleBase from '@/framework/base/components/ModuleBase';
import {RouteElements} from '@/framework/base/classes/Section';
import {CiRouter} from '@/framework/base/helpers/NavHelper';
import Wizard from '@/generated/classes/Wizard';
import Section from '@/framework/base/classes/Section';
import SectionWizard from '@/framework/wizard/components/SectionWizard.vue';
import Fiche from '@/framework/base/classes/Fiche';
import {Fiches, Modules} from '@/generated/classes/AppSchema';
import FicheAdminInfo from '@/framework/admin/components/FicheAdminInfo.vue';
import FicheAdminTable from '@/framework/admin/components/FicheAdminTable.vue';
import {storeSession, storeUser} from '@/generated/stores';
import AdminInfo from '@/extend/classes/AdminInfo';
import User from '@/generated/classes/User';
import {defineComponent, type PropType} from "vue";

export function ModuleAdminOpenFiche(route: Route): RouteElements {
  const section = new Section();
  const fiche = new Fiche();
  if (route && route.fiche) {
    switch (route.fiche) {
      case Fiches.ADMIN_INFO: {
        fiche.component = FicheAdminInfo;
        break;
      }
      case Fiches.ADMIN_TABLE: {
        fiche.component = FicheAdminTable;
        fiche.type = 'adminInfo'
        if (route && route.attribut != null) {
          fiche.data = route.attribut;
        } else if (route && route.section != "") {
          const adminInfo = new AdminInfo();
          adminInfo.table = route.section;
          fiche.data = adminInfo;
        }
        break;
      }
    }
  } else {
    fiche.component = FicheAdminInfo;
  }
  const res = new RouteElements();
  res.fiche = fiche;
  res.section = section;
  return res;
}

export default defineComponent({
  components: {},
  extends: ModuleBase,
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  data() {
    const attribut: unknown = undefined;

    return {
      wizard: new Wizard(),
      attribut,
      notifRoute: new Route(),
      toggleNotif: false
    };
  },
  computed: {
    ressource() {
      return RessourceFwkModule(FwkModules.ADMINISTRATION);
    },
    dataLoaded(): boolean {
      const res = this.wizardDone;
      if (res && !(this.notifRoute && this.notifRoute.id == 0)) {
        if (!this.route) {
          this.selectItem(this.route);
        }
        CiRouter.setRouteChangedSelector(this.routeChanged);
      }
      return res;
    },
    sectionWizard(): Section {
      const section = new Section();
      section.component = SectionWizard;
      section.data = this.wizard;
      section.helper = true;
      return section;
    }
  },
  created() {
    this.notifRoute = this.route;
    const session = storeSession.connectedUser;
    if (session) {
      const user = storeUser.getUser(session.id);
      if (user.modules.includes(Modules.SUPPORT)) {
        this.wizardDone = true;
      }
    }
    if (!this.wizardDone) {
      Wizard.showWizard(Modules.ADMIN).then((res) => {
        if (res.id > 0) {
          this.wizard = res;
          this.showWizard = true;
        } else {
          User.acceptCgu(true);
          this.wizardDone = true;
        }
      })
    }
  },
  methods: {
    routeChanged(route: Route): void {
      this.toggleNotif = !this.toggleNotif;
      this.selectItem(route);
    },
    selectItem(route: Route): void {
      this.notifRoute = route;
      if (route && route.attribut) {
        this.attribut = route.attribut;
      } else {
        this.attribut = undefined;
      }
      const routeElement = ModuleAdminOpenFiche(route);
      this.selectedFiche = routeElement.fiche;
      this.selectedFiche.ressourceHeader = this.ressource;
      const index = this.lastSelectedFiche.findIndex(item => {
        return item.component === this.selectedFiche.component;
      })
      if (index >= 0) {
        this.lastSelectedFiche.splice(index + 1)
      } else {
        this.lastSelectedFiche.push(this.selectedFiche);
      }
    }
  }
})


</script>
